export default __webpack_public_path__ + "static/media/mail.e16ae8aa.svg";